module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_nagoya-be7dd5b62b198d3fb00982bb6b0bb469.jpg";